<template>
  <BaseModal :title="'Xem tệp tin: ' + title" :show.sync="isShow"
             :closeOnBackdrop="false">
    <template v-slot:body-wrapper>
      <div class="modal-body content-fade-in">
        <audio v-show="!hlsPreview" :src="url" controls autoplay style="width: 100%"
               ref="previewAudio"></audio>
        <audio v-show="hlsPreview" controls autoplay style="width: 100%" ref="previewChannelDigitalHLS"></audio>
      </div>
      <BaseFormLoading :loading="loading.value"></BaseFormLoading>
    </template>
    <template v-slot:footer>
      <div slot="footer">
        <button type="button" class="btn btn-secondary" @click="closePreviewAudio()"><i class="fa fa-close"></i> Đóng
        </button>&nbsp;
      </div>
    </template>
  </BaseModal>
</template>
<script>
import BaseFormLoading from "@/views/base/BaseFormLoading";
import BaseModal from "@/views/base/BaseModal";

export default {
  components: {BaseModal, BaseFormLoading},
  props: {
    title: String,
    url: String,
  },
  data() {
    return {
      loading: {value: false},
      isShow: true,
      hlsPreview: '',
    };
  },
  methods: {
    async previewFile() {
      let that = this;
      if (this.url.includes(".m3u8") || this.url.includes(".mpd")) {
        var audio = this.$refs.previewChannelDigitalHLS;
        var urlDetail = this.url.split(",")
        for (var i = 0; i < urlDetail.length; i++) {
          if (urlDetail[i].includes(".mpd")) {} else if (urlDetail[i].includes(".m3u8")) {
            var res = await that.loadViewHLS(urlDetail[i], audio);
            if (res != true) {
              audio.play();
              that.hlsPreview = res;
              setTimeout(() => {
                that.loading.value = false;
              }, 500)
              break;
            }
          } else {
            this.showErrorMsg({message: 'Không thể nghe thử'})
          }
        }
      }
      this.isShow = true;
    },
    async loadViewHLS(url, audio) {
      this.isShow = true;
      this.loading.value = true;
      return new Promise((resolve) => {
        if (Hls.isSupported()) {
          this.loading.value = true;
          var hls = new Hls();
          hls.loadSource(url);
          hls.attachMedia(audio);
          hls.on(Hls.Events.ERROR, function (event, data) {
            var errorFatal = data.fatal;
            resolve(errorFatal);
          });
          hls.on(Hls.Events.MANIFEST_PARSED, function (data) {
            resolve(hls)
          });
        } else {
          this.showErrorMsg({message: 'Không thể nghe thử'})
        }
      })
    },
    closePreviewAudio() {
      if (!this.hlsPreview) {
        this.$refs.previewAudio.pause();
      } else {
        if (this.hlsPreview) {
          this.hlsPreview.destroy();
          this.hlsPreview = '';
        }
      }
      this.isShow = false;
      this.$emit("close-modal", false);
    },
  },
  created() {
  },
  mounted() {
    this.previewFile();
  },
  computed: {},
  watch: {}
};
</script>
<style scoped></style>
